import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Tenant\PricingIndexController::__invoke
* @see app/Http/Controllers/Tenant/PricingIndexController.php:14
* @route '/user/pricing'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/user/pricing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\PricingIndexController::__invoke
* @see app/Http/Controllers/Tenant/PricingIndexController.php:14
* @route '/user/pricing'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\PricingIndexController::__invoke
* @see app/Http/Controllers/Tenant/PricingIndexController.php:14
* @route '/user/pricing'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\PricingIndexController::__invoke
* @see app/Http/Controllers/Tenant/PricingIndexController.php:14
* @route '/user/pricing'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\PricingPaymentController::__invoke
* @see app/Http/Controllers/Tenant/PricingPaymentController.php:16
* @route '/user/pricing/payment'
*/
export const payment = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payment.url(options),
    method: 'get',
})

payment.definition = {
    methods: ["get","head"],
    url: '/user/pricing/payment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\PricingPaymentController::__invoke
* @see app/Http/Controllers/Tenant/PricingPaymentController.php:16
* @route '/user/pricing/payment'
*/
payment.url = (options?: RouteQueryOptions) => {
    return payment.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\PricingPaymentController::__invoke
* @see app/Http/Controllers/Tenant/PricingPaymentController.php:16
* @route '/user/pricing/payment'
*/
payment.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payment.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\PricingPaymentController::__invoke
* @see app/Http/Controllers/Tenant/PricingPaymentController.php:16
* @route '/user/pricing/payment'
*/
payment.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: payment.url(options),
    method: 'head',
})

const pricing = {
    index: Object.assign(index, index),
    payment: Object.assign(payment, payment),
}

export default pricing